import { render } from "./custDefaultLayout.vue?vue&type=template&id=a0305fcc"
import script from "./custDefaultLayout.vue?vue&type=script&lang=js"
export * from "./custDefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__